import { Navigate, Outlet } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import "./PR.css";
import CircularProgress from '@mui/joy/CircularProgress';
import 'react-circular-progressbar/dist/styles.css';
import Maintenance from './Maintenance'; 

const ProtectedRoute = () => {
  let auth = { token: localStorage.getItem('token') };
  let [balance, setBalance] = useState('');
  let [limit, setLimit] = useState('');
  let [loading, setLoading] = useState(true);
  let [settings, setSettings] = useState(null);
  let [userLocationRequired, setUserLocationRequired] = useState(false);
  let [deviceSupportsGeolocation, setDeviceSupportsGeolocation] = useState(false);
  let first = true
  let alertShown = false;
  function getBalance(setBalance, setLimit) {
    axios.get("https://rechargemoi.ma/backend/app/Http/Controllers/settings.json").then((response) => {
      setSettings(response.data);
      if(!alertShown && response.data.alert_enabled && response.data.alert_title && response.data.alert_message){
        alert(response.data.alert_title + "\n\n" + response.data.alert_message);
        alertShown = true;
      }
    })
  if(first){
    setLoading(true);
  }  
  axios.get('https://rechargemoi.ma/backend/api/user', {
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
    .then((response) => {
      setLoading(false);
      if (response.status === 200) {
        setBalance(response.data.balance);
        setLimit(response.data.limit);
        setUserLocationRequired(response.data.location_required == 1);
      }
      if(response.status === 401) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }).catch((error) => {
      setLoading(false);
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      } else {
        
      }
    });
}
  useEffect(() => {
    if (auth.token) {
      if (navigator.geolocation) {
        setDeviceSupportsGeolocation(true);
      }
        if(!(settings && settings.maintenance)){
          getBalance(setBalance, setLimit);
          first = false;
        }
      setInterval(() => {
        if(!(settings && settings.maintenance)){
          getBalance(setBalance, setLimit);
        }
      }, 15000);
    }
  }, [auth.token]);
  return (
    settings && settings.maintenance ? <Maintenance /> :
    auth.token ? 
    (
      <>
        <nav>
          {loading ? <CircularProgress variant="solid" size='sm' color='neutral'/> : balance != '' || balance == 0 ? <h1>{balance + (limit != '' && limit != null ? "/"+limit : '')}</h1>   : <CircularProgress variant="solid" size='sm' color='neutral'/>}
          <div id="icons">
            <i className="fas fa-refresh" onClick={() => {
              window.location.reload();
            }}></i>
            <i id="logout" className="fas fa-sign-out-alt" onClick={() => {
              localStorage.removeItem('token');
              window.location.href = '/login';
            }}></i>
          </div>
        </nav>
        <br />
        <div className='whatsapp'>
          <span>رقم الواتساب: 0601903556</span>
        </div>
        <div className="container">
        <Outlet context={{balance : balance, limit : limit , first : first , offer : settings && settings.offre_enabled , location_required : settings && settings.location_required && userLocationRequired , serverPayment : settings && settings.server_payment }} />
        </div>
        <footer ><div>.</div></footer>
      </>
    ) : (
      <Navigate to='/login' />
    )
  );
};

export default ProtectedRoute;